import { useProductDetailContext } from '@core/utils/models/product/ProductContext'
import ReactMarkdown from 'react-markdown'
import breaks from 'remark-breaks'
import ProductInformation, {
  ProductInformationProps,
} from '@original/components/ProductDetail/ProductDescription/index'
import style from './index.module.less'
import { splitProductDescription } from '../splitProductDescription'

const IgefaProductInformation: React.FC<ProductInformationProps> = (props) => {
  const { product } = useProductDetailContext() || {}
  if (!product || !product.description) {
    return null
  }
  const { descriptionBlock } = splitProductDescription(product.description)

  return (
    <ProductInformation
      {...props}
      slots={{
        description: () => {
          return (
            <ReactMarkdown plugins={[breaks]} className={style.description}>
              {descriptionBlock}
            </ReactMarkdown>
          )
        },
      }}
    />
  )
}

export default IgefaProductInformation
